// In src/components/properties/PropertyModal.js

import React, { useState, useEffect } from 'react';

const PropertyModal = ({ isOpen, onClose, onSubmit, apiError, properties, propertyToEdit }) => {
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [domain, setDomain] = useState('');
    const [email, setEmail] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [billingStatus, setBillingStatus] = useState('PENDING_BILLING');
    const [error, setError] = useState('');
    const isEditMode = !!propertyToEdit;

    useEffect(() => {
        if (isOpen) {
            if (isEditMode) {
                setName(propertyToEdit.name || ''); 
                setCode(propertyToEdit.code || ''); 
                setAddress(propertyToEdit.address || ''); 
                setCity(propertyToEdit.city || ''); 
                setState(propertyToEdit.state || ''); 
                setZipCode(propertyToEdit.zip_code || ''); 
                setDomain(propertyToEdit.domain || ''); 
                setEmail(propertyToEdit.email || '');
                setIsActive(!!propertyToEdit.is_active);
                setBillingStatus(propertyToEdit.status || 'PENDING_BILLING');
            } else {
                setName(''); 
                setCode(''); 
                setAddress(''); 
                setCity(''); 
                setState(''); 
                setZipCode(''); 
                setDomain(''); 
                setEmail('');
                setIsActive(true);
                setBillingStatus('PENDING_BILLING');
            }
            setError('');
        }
    }, [isOpen, propertyToEdit, isEditMode]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (!name || !code) { 
            setError('Property Name and Code are required.'); 
            return; 
        }
        const isDuplicate = properties.some(prop => 
            prop.code.toLowerCase() === code.toLowerCase() && prop.id !== (propertyToEdit ? propertyToEdit.id : null)
        );
        if (isDuplicate) { 
            setError('This Property Code already exists. Please use a unique code.'); 
            return; 
        }
        onSubmit({ name, code, address, city, state, zip_code: zipCode, domain, email, is_active: isActive, status: billingStatus });
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{isEditMode ? 'Edit Property' : 'Add New Property'}</h2>
                <form onSubmit={handleSubmit}>
                    {apiError && <div className="form-error-banner">{apiError}</div>}
                    {error && <div className="form-error-banner">{error}</div>}
                    <div className="form-group"><label className="form-label required" htmlFor="name">Property Name </label><input id="name" className="form-input" type="text" value={name} onChange={(e) => setName(e.target.value)} required /></div>
                    <div className="form-group"><label className="form-label required" htmlFor="code">Property Code </label><input id="code" className="form-input" type="text" value={code} onChange={(e) => setCode(e.target.value)} required /></div>
                    <div className="form-group"><label className="form-label required" htmlFor="domain">Domain</label><input id="domain" className="form-input" type="text" value={domain} onChange={(e) => setDomain(e.target.value)} /></div>
                    <div className="form-group">
                        <label className="form-label required" htmlFor="email">Property Email</label>
                        <input id="email" className="form-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="e.g., contact@property.com" />
                    </div>
                    <div className="form-group"><label className="form-label required" htmlFor="address">Street Address</label><input id="address" className="form-input" type="text" value={address} onChange={(e) => setAddress(e.target.value)} /></div>
                    <div className="form-row">
                        <div className="form-group"><label className="form-labe required" htmlFor="city">City</label><input id="city" className="form-input" type="text" value={city} onChange={(e) => setCity(e.target.value)} /></div>
                        <div className="form-group"><label className="form-label required" htmlFor="state">State</label><input id="state" className="form-input" type="text" value={state} onChange={(e) => setState(e.target.value)} /></div>
                        <div className="form-group"><label className="form-label required" htmlFor="zipCode">Zip Code</label><input id="zipCode" className="form-input" type="text" value={zipCode} onChange={(e) => setZipCode(e.target.value)} /></div>
                    </div>
                    <div className="form-group">
                        <label className="form-label required">Status</label>
                        <div className="toggle-switch-container"><label className="toggle-switch"><input id="prop-active" type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} /><span className="slider"></span></label><span className="toggle-label">{isActive ? 'Active' : 'Inactive'}</span></div>
                    </div>
                    {isEditMode && (
                        <div className="form-group">
                            <label className="form-label required" htmlFor="billingStatus">Billing Status</label>
                            <select id="billingStatus" className="form-input" value={billingStatus} onChange={e => setBillingStatus(e.target.value)}>
                                <option value="PENDING_BILLING">Pending Billing</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                        </div>
                    )}
                    <div className="modal-actions">
                        <button type="button" className="button button-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="button action-button">Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PropertyModal;